export const PLATFORM_DBA_SERVICES_RESET_STATE = 'PLATFORM_DBA_SERVICES_RESET_STATE';
export const PLATFORM_DBA_SERVICES_CURRENT_ITEM = 'PLATFORM_DBA_SERVICES_CURRENT_ITEM';

export const PLATFORM_DBA_SERVICES_REQUEST_LOADING = 'PLATFORM_DBA_SERVICES_REQUEST_LOADING';
export const PLATFORM_DBA_SERVICES_REQUEST_SUCCESS = 'PLATFORM_DBA_SERVICES_REQUEST_SUCCESS';
export const PLATFORM_DBA_SERVICES_REQUEST_FAILED = 'PLATFORM_DBA_SERVICES_REQUEST_FAILED';

export const PLATFORM_DBA_SERVICES_CURRENT_ACTION = 'PLATFORM_DBA_SERVICES_CURRENT_ACTION';
export const PLATFORM_DBA_SERVICES_RESET_ACTION = 'PLATFORM_DBA_SERVICES_RESET_ACTION';